module.exports = __webpack_public_path__ + "img/united-rugby-championship-logo-colour.397e33d5.png";